import { Directive, Input, TemplateRef } from "@angular/core";

const DEFAULT_PREVIEW_TEXT_LENGTH = 650;

@Directive({
    selector: "[dtmMainPageLibKpoNewsSlide]",
})
export class KpoNewsSlideDirective {
    @Input() public newsTitle: string | undefined;
    @Input() public newsDate: Date | string | undefined;
    /**
     * Override the default preview content with a custom one.
     */
    @Input() public previewContent: string | TemplateRef<HTMLElement> | undefined;
    @Input() public previewLength: number | string = DEFAULT_PREVIEW_TEXT_LENGTH;
    @Input() public id: string | undefined;

    constructor(public template: TemplateRef<HTMLElement>) {}
}
